export default __webpack_public_path__ + "static/media/boomerang_logo_white.2b9a3dd3.svg";